import i18next from "i18next";
import { Form, Icon, Input, Button, Layout, Switch, Typography } from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { UserService } from "../../services/user/UserService";
import { showSuccessToast } from "../general/ToastHelper";
import { handleError } from "../../utils/ErrorHandlers";

const { Text } = Typography;

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("forgotPassword");
    this.state = {
      loading: false,
    };
  }
  componentDidMount() {}
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let { updateUserAndSession } = this.props.context;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.userService = new UserService();
          let data = await this.userService.resetPasswordForForget(null, {
            email: values["userEmail"],
          });

          showSuccessToast(i18next.t("Password has been reseted successfully"));
          this.setState({ loading: false });
          this.props.backToLogin();
          this.props.form.resetFields();
        }
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <h3>{i18next.t("Forgot password?")}</h3>
        <Text>
          {i18next.t(
            "Enter the email address or mobile number tied to your account to reset your password"
          )}
        </Text>
        <Form.Item style={{ marginTop: 10 }}>
          {getFieldDecorator("userEmail", {
            rules: [
              {
                required: true,
                message: i18next.t("Please enter your email or mobile number"),
              },
            ],
          })(
            <Input
              prefix={<Icon type="user" className="input-icon" />}
              placeholder={i18next.t("Email or mobile number")}
            />
          )}
        </Form.Item>
        <Form.Item>
          <a
            className="login-form-forgot"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.backToLogin();
            }}
          >
            {i18next.t("Back to login")}
          </a>
          <Button
            type="primary"
            onClick={this.handleConfirm}
            className="login-form-button"
            loading={this.state.loading}
          >
            {i18next.t("Reset Password")}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Form.create()(
  withSharedStateConsumer(withRouter(ForgotPassword))
);
